<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="value"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card flat>
        <v-toolbar dark color="gradiente">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar height="90" v-if="poll">
          <v-flex xs12 md3 lg3 px-4>
            <v-toolbar-title>
              {{ $t('surveys.survey_details') }}
            </v-toolbar-title>
          </v-flex>
          <v-flex xs12 md3 lg3 px-4 v-if="poll.startDate">
            <DatePicker
              :titleDate="$t('surveys.start_date')"
              v-model="startDateSearch"
              v-if="poll.periodicity !== 'SINGLE'"
              :clean="true"
              :min="getDateStartPoll(poll.startDate)"
              :max="getDateEndPoll(poll.endDate)"
              @change="getPollAll"
            />
          </v-flex>
          <v-flex xs12 md3 lg3 px-4 v-if="poll.startDate">
            <DatePicker
              :titleDate="$t('surveys.end_date')"
              v-model="endDateSearch"
              v-if="poll.periodicity !== 'SINGLE'"
              :clean="true"
              :min="getDateStartPoll(poll.startDate)"
              :max="getDateEndPoll(poll.endDate)"
              @change="getPollAll"
            />
          </v-flex>
          <v-flex xs12 md3 lg3 class="titleSearch">
            <v-text-field
              flat
              :label="$t('generic.search')"
              append-outer-icon="search"
              clearable
              solo-inverted
              hide-details
              @click:append-outer="filterSearch(false)"
              @click:clear="filterSearch(true)"
              @keyup.enter="filterSearch(false)"
              v-model="search"
            />
          </v-flex>
        </v-toolbar>
        <v-toolbar height="130">
          <v-flex xs12 md3 lg3>
            <v-list light style="background-color: transparent">
              <div class="padding-side">
                <v-text-field
                  :value="poll ? poll.title : ''"
                  rows="1"
                  row-height="24"
                  auto-grow
                  disabled
                />
              </div>
            </v-list>
          </v-flex>
        </v-toolbar>
        <v-container fluid style="max-height: 93vh" class="scrollDesign">
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :rows-per-page-items="[25, 50, 75, 100]"
                :items="pollStudents"
                :loading="working.wPolls"
                :pagination.sync="pagination"
                item-key="id"
                no-results-text="No se encontraron coincidencias"
                :no-data-text="
                  working.wPolls
                    ? 'Cargando'
                    : pollStudents.length > 0
                    ? ''
                    : 'No hay alumnos'
                "
                :total-items="totalItemsFromBackend"
              >
                <template v-slot:headers>
                  <tr>
                    <th
                      class="text-xs-center"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ $t('surveys.date_and_time') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 140px; max-width: 140px; min-width: 140px"
                    >
                      {{ $t('surveys.status') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 170px; max-width: 170px; min-width: 170px"
                    >
                      {{ $t('surveys.registration') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 170px; max-width: 170px; min-width: 170px"
                    >
                      {{ $t('surveys.name') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 170px; max-width: 170px; min-width: 170px"
                    >
                      {{ $t('surveys.last_name') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 180px; max-width: 180px; min-width: 180px"
                    >
                      {{ $t('surveys.level') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 130px; max-width: 130px; min-width: 130px"
                    >
                      {{ $t('surveys.grade') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 130px; max-width: 130px; min-width: 130px"
                    >
                      {{ $t('surveys.group') }}
                    </th>
                    <th
                      class="text-xs-center"
                      style="width: 100px; max-width: 100px; min-width: 100px"
                    >
                      {{ $t('surveys.answers') }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td
                    class="text-xs-center"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ props.item.answeredAt | formatDate }}
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 140px; max-width: 140px; min-width: 140px"
                    v-if="props.item.status == 'DONE'"
                  >
                    Contestada
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 140px; max-width: 140px; min-width: 140px"
                    v-else-if="props.item.status == 'PENDING'"
                  >
                    Sin Contestar
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 170px; max-width: 170px; min-width: 170px"
                  >
                    {{ props.item.student.personId }}
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 170px; max-width: 170px; min-width: 170px"
                  >
                    {{ props.item.student.firstName }}
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 170px; max-width: 170px; min-width: 170px"
                  >
                    {{ props.item.student.lastName }}
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 180px; max-width: 180px; min-width: 180px"
                  >
                    {{ props.item.student.level.typeLevel }}
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 130px; max-width: 130px; min-width: 130px"
                  >
                    {{ props.item.student.gradeGroup.grade }}
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 130px; max-width: 130px; min-width: 130px"
                  >
                    {{ props.item.student.gradeGroup.group }}
                  </td>
                  <td
                    class="text-xs-center"
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    <v-btn icon :disabled="props.item.status == 'PENDING'">
                      <v-icon class="no-border" @click="expandAns(props)">{{
                        'info_outline'
                      }}</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template v-slot:expand="props">
                  <Ans
                    v-if="expandables.Ans"
                    :datails="props.item.details"
                  ></Ans>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { funciones } from '../../../Mixins/Funciones'
import DatePicker from '../../Tools/DatePicker'
import Ans from './AnswersComponent.vue'

export default {
  components: {
    DatePicker,
    Ans,
  },
  mixins: [funciones],
  props: ['value', 'poll', 'idPoll'],
  data: () => ({
    pagination: {
      sortBy: 'name',
    },
    filters: {
      search: '',
    },
    working: {
      wPolls: false,
    },
    totalItemsFromBackend: 0,
    search: '',
    startDateSearch: '',
    endDateSearch: '',
    avatarSize: '30px',
    pollStudents: [],
    ans: [],
    headers: [
      {
        text: 'Fecha y hora',
        align: 'left',
        value: 'firstName',
        filterItems: [],
      },
      {
        text: 'Estatus',
        align: 'left',
        value: 'status',
        filterItems: [],
      },
      {
        text: 'Matrícula',
        align: 'left',
        value: 'personId',
        filterItems: [],
      },
      {
        text: 'Apellido',
        align: 'left',
        value: 'lastName',
        filterItems: [],
      },
      {
        text: 'Nivel',
        value: 'level.grade',
        align: 'left',
        filterItems: [],
      },
      {
        text: 'Grupo',
        value: 'gradeGroup.grade',
        filterItems: [],
        align: 'center',
      },
      {
        text: 'Estatus',
        value: 'hasAlerts',
        filterItems: [],
        align: 'center',
      },
      {
        text: 'Respuestas de aalerta',
        filterItems: [],
        align: 'center',
      },
      {
        text: 'Descargar',
        value: '',
        filterItems: [],
        align: 'center',
      },
    ],
    expandables: {
      Ans: false,
      isOculto: false,
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
  }),
  watch: {
    value() {
      this.getPollAll(true)
    },
    startDateSearch() {
      this.getPollAll(true)
    },
    endDateSearch() {
      this.getPollAll(true)
    },
    pagination: {
      handler() {
        if (
          this.pagination.rowsPerPage &&
          this.pagination.page &&
          this.pagination.sortBy
        ) {
          this.filters.size = this.pagination.rowsPerPage
          this.filters.offset =
            (this.pagination.page - 1) * this.pagination.rowsPerPage
          this.filters.orderBy = this.pagination.sortBy
          this.filters.orderType = this.pagination.descending ? 'DESC' : 'ASC'
          if (this.value && this.poll != null) {
            this.getPollAll(true)
          }
        }
      },
      deep: true,
    },
  },
  filters: {
    pollStatus: function (value) {
      switch (value) {
        case 'DONE':
          return 'Pendiente'
        case 'PENDING':
          return 'Publicado'
      }
    },
  },
  methods: {
    expandAns(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          Ans: false,
          isOculto: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.Ans) {
        props.expanded = !props.expanded
        this.expandables = {
          Ans: false,
          isOculto: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.Ans) {
        props.expanded = !props.expanded

        this.expandables = {
          Ans: true,
          isOculto: false,
        }

        this.ans = props
      } else if (props.expanded && !this.expandables.Ans) {
        this.expandables = {
          Ans: true,
          isOculto: false,
        }
        this.ans = props
      }
    },
    getDateStartPoll(startDateDouble) {
      if (startDateDouble !== undefined) {
        return new Date(startDateDouble).toLocaleDateString('sv-SE')
      }
    },
    getDateEndPoll(endDateDouble) {
      if (endDateDouble !== undefined) {
        return new Date(endDateDouble).toLocaleDateString('sv-SE')
      }
    },
    getPollAll(forceUpdate) {
      var offset = ''
      var pageSize = ''
      if (this.pagination.rowsPerPage !== undefined) {
        offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
        pageSize = this.pagination.rowsPerPage
      } else {
        offset = 0
        pageSize = 10
      }
      this.working.wPolls = true
      var params = {
        search: this.search,
        size: pageSize,
        offset: offset,
      }
      if (this.startDateSearch && this.startDateSearch !== '') {
        params.from = new Date(this.startDateSearch).toISOString().substr(0, 10)
      }
      if (this.endDateSearch && this.endDateSearch !== '') {
        params.to = new Date(this.endDateSearch).toISOString().substr(0, 10)
      }

      this.$store
        .dispatch('polls/getAllResults', {
          idPoll: this.idPoll,
          params: params,
        })
        .then((response) => {
          this.working.wPolls = false
          this.pollStudents = response.data.data
          this.totalItemsFromBackend = response.data.total
          if (forceUpdate) {
            this.$forceUpdate()
          }
        })
        .catch(() => {
          this.working.wPolls = false
        })
    },
    close() {
      this.$emit('input', !this.value)
    },
    filterSearch(clean) {
      if (!clean) {
        this.filters.search = this.search ? this.search : ''
      } else {
        this.filters.search = ''
      }
      if (!this.working.wPolls) {
        this.getPollAll(true)
      }
    },
    downloadAll() {
      this.$store
        .dispatch('polls/getAllData', this.poll.id)
        .then((response) => {
          this.working.wPolls = false
          var pollDownload = response.data
          pollDownload.isAll = true
          this.download('poll', pollDownload)
        })
        .catch(() => {
          this.working.wPolls = false
        })
    },
    downloadPoll(item) {
      var params = {
        id: this.poll.id,
        idStudent: item.student.id,
      }
      if (this.startDateSearch !== null && this.startDateSearch !== '') {
        params.from = this.startDateSearch.getTime()
      }
      if (this.endDateSearch !== null && this.endDateSearch !== '') {
        params.to = this.endDateSearch.getTime()
      }
      this.$store
        .dispatch('polls/getDataFile', params)
        .then((response) => {
          this.working.wPolls = false
          var resultsArray = response.data.results
          var pollDownload = {
            results: resultsArray,
            title: this.poll.title,
            questions: this.poll.questions,
          }
          pollDownload.isAll = false
          this.download('poll', pollDownload)
        })
        .catch(() => {
          this.working.wPolls = false
        })
    },
    getIcon(item) {
      if (item.polls === item.completedPolls) {
        return require('@/assets/payments/payment_student_paid.png')
      }
      return require('@/assets/payments/payment_student_pending.png')
    },

    getIconAlert(item) {
      if (item.hasAlerts == false) {
        if (item.completedPolls == false) {
        }
        return require('@/assets/polls/icons/alertaC.png')
      } else {
        return require('@/assets/polls/icons/alerta1.png')
      }
    },
  },
  filters: {
    periodicityFilter: function (value) {
      switch (value) {
        case 'SINGLE':
          return 'Solo una vez'
        case 'DAILY':
          return 'Diario'
        case 'WEEKLY':
          return 'Semanal'
        case 'MONTHLY':
          return 'Mensual'
      }
    },
    statusResult: function (item) {
      if (item.polls === 1) {
        if (item.completedPolls === 1) {
          return 'Contestada'
        }
        return 'Sin contestar'
      }

      if (item.polls === item.completedPolls) {
        return 'Contestadas ' + item.completedPolls + ' de ' + item.polls
      }
      return (
        'Sin contestar ' +
        (item.polls - item.completedPolls) +
        ' de ' +
        item.polls
      )
    },
  },
}
</script>

<style></style>
